var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroPiezaRompecabezas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.89 534.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4584ff;}.cls-2{fill:#153989;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480,303.77,595.89,115.48,407.94,0,366.12,68.07A41.14,41.14,0,1,1,334.21,120L292.47,188l72.95,44.82a2.89,2.89,0,0,1-1.08,5.21L364,238h0a35.63,35.63,0,1,0,39.41,24.23v0h0c0-.11-.08-.23-.11-.34a2.9,2.9,0,0,1,4.23-3.25h0l72.88,44.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152,424.48A41.14,41.14,0,0,1,220.75,394V314.19H135.12a2.9,2.9,0,0,1-2.67-2.89,2.87,2.87,0,0,1,.92-2.11l.24-.21h0l0,0a35.63,35.63,0,1,0-46.3,0h0l0,0a2,2,0,0,1,.27.23,2.89,2.89,0,0,1-1.87,5H.17V534.78H220.75V454.94A41.14,41.14,0,0,1,152,424.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.56,534.78H226V449.16a2.9,2.9,0,0,0-5-1.8,1.59,1.59,0,0,0-.2.24h0a35.63,35.63,0,1,1,0-46.27v0h0a2.1,2.1,0,0,0,.24.27,2.85,2.85,0,0,0,2.08.89,2.91,2.91,0,0,0,2.9-2.79h0V314.19h79.81a41.14,41.14,0,1,0,61,0h79.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,229.32v79.83H79.86a41.14,41.14,0,1,1,60.93,0h79.8V223.54a2.9,2.9,0,0,1,5-1.81l.21.24h0l.16.18a35.64,35.64,0,1,0,0-46.61,1.07,1.07,0,0,1-.14.16l0,0-.23.27a2.9,2.9,0,0,1-5-1.9h0V88.56H0V168.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPiezaRompecabezas);
export default __webpack_public_path__ + "static/media/HeroPiezaRompecabezas.14a0606979b6c828aac8b3b117dea97f.svg";
export { ForwardRef as ReactComponent };